import React from "react";
import { Box, Stack, Typography } from "@mui/material";

/**
 * ExperienceItem
 * -----------------------------
 * Reusable Lite component for:
 * - Icon + title + description rows
 * - Guarantees alignment & spacing
 * - Uses MUI 8-pt grid
 *
 * Usage:
 * <ExperienceItem
 *   icon="🎯"
 *   title="Clarity before ideas"
 *   text="Description text..."
 * />
 */

const ExperienceItem = ({ icon, title, text }) => {
  return (
    <Stack
      direction="row"
      spacing={3} // 24px → 3 × 8pt grid
      alignItems="flex-start"
    >
      {/* Icon column (fixed width for alignment) */}
      <Box
        sx={{
          width: 48,            // 6 × 8pt
          display: "flex",
          justifyContent: "center",
          fontSize: 32,         // 4 × 8pt
          lineHeight: 1,
          pt: "2px",            // optical baseline alignment
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>

      {/* Text column */}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            mb: 1,              // 8px → 1 × 8pt
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.7,
          }}
        >
          {text}
        </Typography>
      </Box>
    </Stack>
  );
};

export default ExperienceItem;
